import * as React from 'react';
import { SearchIcon } from './Icons.js';

export function EmptyState({ query }: { query: string }) {
  return (
    <section className="empty-state" data-testid="catalog-empty">
      <span className="empty-icon"><SearchIcon /></span>
      <h2>Ничего не найдено</h2>
      <p>По запросу «{query}» нет канонических товаров в демонстрационном наборе.</p>
      <p className="muted">Проверьте артикул или используйте R28003 и A7712 для представительских сценариев.</p>
    </section>
  );
}
